/* Studio Spice · v1.2 small enhancements · v1.6 quiz link */
(function () {
  var d = document;
  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    /* PDP title: "Name | Descriptor" -> name + muted descriptor line */
    var h = d.querySelector('.product__title h1');
    if (h && !h.querySelector('.sb-ptitle-sub')) {
      for (var i = 0; i < h.childNodes.length; i++) {
        var n = h.childNodes[i];
        if (n.nodeType !== 3) continue;
        var t = n.nodeValue, sep = t.indexOf(' | ') > -1 ? ' | ' : (t.indexOf(' - ') > -1 ? ' - ' : '');
        if (!sep) continue;
        var parts = t.split(sep), name = parts.shift().trim(), rest = parts.join(sep).trim();
        if (!rest) break;
        n.nodeValue = name + ' ';
        var s = d.createElement('span');
        s.className = 'sb-ptitle-sub';
        s.textContent = rest.charAt(0).toUpperCase() + rest.slice(1);
        h.appendChild(s);
        break;
      }
    }
    /* upsell + cart titles: keep the product name, descriptor in a muted line */
    function split(el) {
      if (el.children.length || el.getAttribute('data-sb-split')) return;
      var t = el.textContent, sep = t.indexOf(' | ') > -1 ? ' | ' : (t.indexOf(' - ') > -1 ? ' - ' : '');
      if (!sep) return;
      var p = t.split(sep), name = p.shift().trim(), rest = p.join(sep).trim();
      el.setAttribute('data-sb-split', '1');
      el.textContent = name;
      var s = d.createElement('span'); s.className = 'sb-title-sub'; s.textContent = rest.charAt(0).toUpperCase() + rest.slice(1);
      el.appendChild(s);
    }
    function splitAll() { Array.prototype.forEach.call(d.querySelectorAll('.upsell-title, a.cart-item__name'), split); }
    splitAll();
    if ('MutationObserver' in window) {
      var cd = d.querySelector('cart-drawer') || d.getElementById('CartDrawer');
      if (cd) new MutationObserver(splitAll).observe(cd, { childList: true, subtree: true });
      var cp = d.querySelector('cart-items');
      if (cp) new MutationObserver(splitAll).observe(cp, { childList: true, subtree: true });
    }
    /* predictive search: match the store's price format (€14,95) */
    var sr = d.querySelector('[data-sb-search-results]');
    if (sr && 'MutationObserver' in window) {
      new MutationObserver(function () {
        Array.prototype.forEach.call(sr.querySelectorAll('.sb-sres__p'), function (el) {
          var m = el.textContent.match(/^\s*€\s?(\d+)\.(\d{2})\s*$/);
          if (m) el.textContent = '€' + m[1] + ',' + m[2];
        });
      }).observe(sr, { childList: true, subtree: true });
    }
    /* PDP: quiet link to the Find your blend quiz under the buy button (teas + cacao only) */
    var pf = d.querySelector('product-form.main-product-form');
    var ph = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    if (pf && /blend|tea|cacao|bundle/.test(ph) && !d.querySelector('.sb-pquiz')) {
      var nlq = /^nl/.test(d.documentElement.lang || '');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var a = d.createElement('a');
      a.className = 'sb-pquiz';
      a.href = root + 'pages/find-your-blend';
      a.innerHTML = '<span>' + (nlq ? 'Twijfel je of dit jouw blend is?' : 'Not sure this is your blend?') + '</span> <u>' + (nlq ? 'Doe de quiz van een minuut' : 'Take the one-minute quiz') + '</u>';
      pf.parentNode.insertBefore(a, pf.nextSibling);
    }
    /* collection chips: /collections/all counts as "All products" */
    if (/\/collections\/all\/?$/.test(location.pathname)) {
      var c = d.querySelector('.sb-chips a[href$="/collections/all-products"]');
      if (c && !d.querySelector('.sb-chips [aria-current]')) c.setAttribute('aria-current', 'page');
    }
  });
})();
